import React from 'react'
import ParentStyles from '../../styles'
import Styles from './styles.js'
import { ArrowLeft, ArrowRight } from 'react-feather'
import { FormattedMessage, useIntl } from 'react-intl'
import NoContent from '~/components/NoContent'
import { Show } from '~/components/commons'
import DefaultFallbackImage from '~/assets/img/fallbacks/default.png'

function CardStructure({ title, date, image, id }) {
  const intl = useIntl()
  const locale = intl.locale === 'en' ? 'en-US' : 'pt-BR'
  const dateFormat = new Date(date).toLocaleDateString(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })
  return (
    <a href={`/schedule/${id}`}>
      <Styles.CardContainer>
        <Styles.CardImage src={image || DefaultFallbackImage} />
        <Styles.CardTexts>
          <Styles.CardDate>{dateFormat}</Styles.CardDate>
          <Styles.CardTitle>{title}</Styles.CardTitle>
        </Styles.CardTexts>
      </Styles.CardContainer>
    </a>
  )
}

function CardsWrapper({ children }) {
  const ref = React.useRef(null)
  const [currentChildren, setCurrentChildren] = React.useState(1)
  const [hasNext, setHasNext] = React.useState(false)
  const [hasPrev, setHasPrev] = React.useState(false)
  const [isLast, setIsLast] = React.useState(false)

  React.useEffect(() => {
    if (!ref.current) return
    const parentWidth = document.querySelector('.scheduled-publications')
      .clientWidth
    const childrensInView = Math.floor(parentWidth / 216)
    const val = parentWidth - 24 - childrensInView * 216

    const move = isLast ? val : 0
    ref.current.scrollTo({
      left: 216 * (currentChildren - 1) - move,
      behavior: 'smooth',
    })
  }, [currentChildren, ref.current])

  React.useEffect(() => {
    if (!ref.current) return
    if (ref.current.scrollWidth < ref.current.clientWidth) return
    const parentWidth = document.querySelector('.scheduled-publications')
      .clientWidth
    const childrensInView = Math.floor(parentWidth / 200) - 1
    const childrenCount =
      Array.from(ref.current.children).filter(
        el => !el.classList.contains('no-count')
      ).length - childrensInView

    if (currentChildren === childrenCount) {
      setHasNext(false)
    } else {
      setHasNext(true)
    }

    if (currentChildren === childrenCount - 1) {
      setIsLast(true)
    } else {
      setIsLast(false)
    }

    if (currentChildren === 1) {
      setHasPrev(false)
    } else {
      setHasPrev(true)
    }

    if (childrenCount < childrensInView) {
      setHasNext(false)
      setHasPrev(false)
    }
  }, [currentChildren, ref.current])

  const scrollToNext = () => {
    if (!ref.current) return
    const count = Array.from(ref.current.children).filter(
      el => !el.classList.contains('no-count')
    ).length
    if (currentChildren === count) return

    setCurrentChildren(prev => prev + 1)
  }

  const scrollToPrev = () => {
    if (!ref.current) return
    if (currentChildren === 1) return

    setCurrentChildren(prev => prev - 1)
  }

  return (
    <Styles.CardsWrapper>
      <div ref={ref} className="card-list-wrapper">
        {children}
      </div>
      {hasPrev && (
        <div
          className="ghost-button ghost-button-left no-count"
          onClick={scrollToPrev}
        >
          <div>
            <ArrowLeft width={24} />
          </div>
        </div>
      )}
      {hasNext && (
        <div
          className="ghost-button ghost-button-right no-count"
          onClick={scrollToNext}
        >
          <div>
            <ArrowRight width={24} />
          </div>
        </div>
      )}
    </Styles.CardsWrapper>
  )
}

export default function ScheduledPostsSection({ schedules = [] }) {
  return (
    <ParentStyles.Box className="scheduled-publications">
      <ParentStyles.Title>
        <FormattedMessage id={'Scheduled publications'} />
      </ParentStyles.Title>
      <Show condition={schedules?.length}>
        <CardsWrapper>
          {schedules.map(el => (
            <CardStructure
              date={el.publishedAt}
              title={el.title}
              image={el.image}
              id={el.id}
              key={el.id}
            />
          ))}
        </CardsWrapper>
      </Show>
      <Show condition={!schedules?.length}>
        <NoContent padding={'0 24px'} gap={'16px'}>
          <NoContent.Icon />
          <NoContent.Description>
            <FormattedMessage id={'homeScheduledPublicationsNoContent'} />
          </NoContent.Description>
        </NoContent>
      </Show>
      <a href="/publications">
        <ParentStyles.BlackButton>
          <FormattedMessage id={'homeScheduledPublicationsButton'} />
        </ParentStyles.BlackButton>
      </a>
    </ParentStyles.Box>
  )
}
